module.exports = __webpack_public_path__ + "img/subscription_active.7b8864e1.svg";